var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-box" },
    [
      _vm.postForgotPassword
        ? _c("div", [
            _vm._v(
              "\n\t\tSofern diese E-Mail bei uns vorhanden ist, bekommst du in Kürze ein E-Mail mit einem Link, um dein Passwort\n\t\tzurücksetzen zu können.\n\t"
            )
          ])
        : [
            _vm.isPostPasswordReset
              ? _c("p", [
                  _vm._v(
                    "\n\t\t\tDu hast dein Passwort erfolgreich geändert und kannst dich nun anmelden:\n\t\t"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isAutoLogout
              ? _c("p", [
                  _vm._v(
                    "\n\t\t\tAus Sicherheitsgründen wurdest du aufgrund zu langer Inaktivität automatisch abgemeldet.\n\t\t"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.login.apply(null, arguments)
                  }
                }
              },
              [
                _c("b-input", {
                  attrs: { placeholder: "E-Mail Adresse" },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.login.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.email,
                    callback: function($$v) {
                      _vm.email = $$v
                    },
                    expression: "email"
                  }
                }),
                _vm._v(" "),
                !_vm.forgotPassword
                  ? _c(
                      "div",
                      { staticClass: "mt-3" },
                      [
                        _c("b-input", {
                          ref: "password",
                          attrs: { type: "password", placeholder: "Passwort" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.login.apply(null, arguments)
                            }
                          },
                          model: {
                            value: _vm.password,
                            callback: function($$v) {
                              _vm.password = $$v
                            },
                            expression: "password"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "mt-3" }, [
                  _c("div", { staticClass: "login-box--actions" }, [
                    _c(
                      "div",
                      [
                        _vm.forgotPassword
                          ? _c("Button", {
                              attrs: {
                                text: "Link anfordern",
                                disabled:
                                  !_vm.forgotPasswordDataValid ||
                                  _vm.resettingPassword,
                                loading: _vm.resettingPassword,
                                icon: "checkmark"
                              },
                              on: { click: _vm.resetPassword }
                            })
                          : _c("Button", {
                              attrs: {
                                text: "Anmelden",
                                disabled: !_vm.dataValid || _vm.loggingIn,
                                loading: _vm.loggingIn,
                                icon: "checkmark"
                              },
                              on: { click: _vm.login }
                            })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.forgotPassword
                      ? _c("div", [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.changeForgotPassword(false)
                                }
                              }
                            },
                            [_vm._v("Zum Login")]
                          )
                        ])
                      : _c("div", [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.changeForgotPassword(true)
                                }
                              }
                            },
                            [_vm._v("Passwort vergessen?")]
                          )
                        ])
                  ]),
                  _vm._v(" "),
                  _vm.error
                    ? _c("div", { staticClass: "error mt-3" }, [
                        _vm._v("Logindaten fehlerhaft")
                      ])
                    : _vm._e()
                ])
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }